import { LoadingState } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function LoadingCustomersList() {
  const { t } = useTranslation();

  return (
    <LoadingState
      title={t("customers.list.messages.loading_title")}
      description={t("customers.list.messages.loading_description")}
    />
  );
}
